// utils/employeeFormatters.js
// Place in: src/utils/employeeFormatters.js

// ── Phone formatter ────────────────────────────────────────────────────────────
// Formats as user types → 0300-1234567
export const formatPhone = (val) => {
  if (!val) return val;
  let digits = String(val).replace(/\D/g, '');
  if (digits.startsWith('92') && digits.length >= 12) digits = '0' + digits.slice(2);
  if (digits.length > 11) digits = digits.slice(0, 11);
  if (digits.length > 4) return digits.slice(0, 4) + '-' + digits.slice(4);
  return digits;
};

// ── CNIC formatter ─────────────────────────────────────────────────────────────
// Formats as user types → 12345-1234567-1
export const formatCnic = (val) => {
  if (!val) return val;
  let digits = String(val).replace(/\D/g, '');
  if (digits.length > 13) digits = digits.slice(0, 13);
  if (digits.length > 12) return digits.slice(0, 5) + '-' + digits.slice(5, 12) + '-' + digits.slice(12);
  if (digits.length > 5)  return digits.slice(0, 5) + '-' + digits.slice(5);
  return digits;
};